import React from 'react';
import * as S from './ButtonStyle';

export function Button({ $type, $size, children, onClick, ...props }) {
  return (
    <S.Btn $type={$type || 'standard'} $size={$size} onClick={onClick} {...props}>
      {children}
    </S.Btn>
  );
}
